import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Button, Divider, Header, Loader } from 'semantic-ui-react'

import PromotionForm from '../forms/promotionForm'

import ListPromotions from './ListPromotions'
import RestaurantActions from '../../../reducers/restaurantReducer'
import PickUpPromotionActions from '../../../reducers/pickUpPromotionReducer'

const styles = {
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  header: {
    margin: 0,
  }
}

class PromotionList extends React.Component {
  state = {
    formVisible: false,
    promotionData: null,
    action: '',
  }

  componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, getPromotions } = this.props

    getPromotions()

    if (!restaurantLoaded) fetchRestaurants()
  }

  onEdit = promotionData => {
    this.setState({ promotionData, action: 'edit', formVisible: true })
  }

  onDelete = promotion => {
    const { deletePromotion } = this.props
    // eslint-disable-next-line no-alert
    const confirm = window.confirm('Are you sure you want to delete the promotion?')

    if (confirm) {
      deletePromotion(promotion.key)
    }
  }

  render() {
    const { formVisible, action, promotionData } = this.state
    const { restaurantLoaded, restaurants, promotions } = this.props

    const promotionByMerchant = _.groupBy(Object.values(promotions.data), 'merchant_id')

    if (!restaurantLoaded) return <Loader active />

    return (
      <React.Fragment>
        <div style={styles.headerWrapper}>
          <Header style={styles.header}>
            {`Pick Up Promotions (${_.size(promotionByMerchant)})`}
          </Header>
          <Button
            color="black"
            icon="add"
            content="Add New"
            onClick={() => this.setState({ action: 'new', formVisible: true })}
          />
        </div>

        <Divider />

        {_.size(promotions.data) === 0 ? (
          <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>
        ) : (
          <div className="branches-summary">
            <ListPromotions
              promotionByMerchant={promotionByMerchant}
              restaurants={restaurants}
              onDelete={this.onDelete}
              onEdit={this.onEdit}
              action={action}
            />
          </div>
        )}

        {formVisible && (
          <PromotionForm
            restaurants={restaurants}
            promotionData={promotionData}
            action={action}
            onClose={() => this.setState({ formVisible: false, promotionData: null })}
          />
        )}
      </React.Fragment>
    )
  }
}

const mapState = ({ restaurants, items, pickUpPromotions }) => ({
  promotions: pickUpPromotions,
  items: items.data,
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getPromotions: PickUpPromotionActions.getPickUpPromotions,
  deletePromotion: PickUpPromotionActions.deletePickUpPromotion,
}

export default connect(
  mapState,
  mapDispatch
)(PromotionList)



// WEBPACK FOOTER //
// ./src/components/pickUpPromotions/views/PromotionsList.js